import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px;
  height: 100%;
  width: 100%;

  > img {
    justify-self: flex-start;
    height: auto;
    width: 180px;
  }
`;

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  > form {
    padding: 30px 0;

    > h1 {
      font-size: 22px;
      color: #2c405a;
      text-align: center;
    }

    button#btn-submit {
      background: #ff6d3c;
      border: 0;
      color: #fff;
      font-size: 15px;
      margin-top: 30px;
      border-radius: 5px;
      padding: 10px 20px;
      min-width: 150px;
      transition: background 1s;

      :hover {
        background: ${shade(0.2, '#ff6d3c')};
      }
    }

    button {
      background: none;
      border: 0;
      font-weight: bold;
      font-size: 12px;
      color: #ff6d3c;
      transition: color 1s;

      :hover {
        color: ${shade(0.2, '#ff6d3c')};
      }
    }

    #btn-forgot {
      text-align: left;
    }

    #btn-signup {
      margin-left: 5px;
    }

    > span {
      color: #2c405a;
      padding: 10px;
      font-size: 12px;
      text-align: center;
    }
  }
`;
